<template>
  <router-link v-if="modules && !!modules['invoices']" to="/app/bookings/invoices/wizards" class="btn btn-link ml-auto">
    <fa-icon icon="magic" />
    Invoices Wizards
  </router-link>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faMagic } from '@fortawesome/free-solid-svg-icons';

library.add(faMagic);

export default {
  computed: {
    modules () {
      return this.$store.getters.modules;
    },
  },
};
</script>
